import { DriverInformation } from "../../../dispatch/src/DriverInformation";
import { CarrierPrequalResult } from "../CarrierPrequalResult";
import { DispatchCommentsErrors } from "../DispatchCommentsErrors";
import { MovementPay } from "../MovementPay";
import { RecentCallins } from "../RecentCallins";
import { Button, Checkbox, CityState, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, StarRating, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierAssignment extends Layout {
    btnPrequalCarrier: Button;
    buttonCancel: Button;
    buttonDownloadImages: Button;
    buttonGetTrackingStatus: Button;
    buttonRestartTracking: Button;
    checkboxBOL: Checkbox;
    checkboxDR: Checkbox;
    checkboxInvoice: Checkbox;
    checkboxWIC: Checkbox;
    citystateCarrierEmptyFromCityId: CityState;
    dfLabel: Label;
    horizontalspacer3: HorizontalSpacer;
    imageCarrierVerification: Image;
    labelAddress1: Label;
    labelCarrierCity: CityState;
    labelCarrierContact: Label;
    labelCarrierReference: Label;
    labelDest: Label;
    labelDriverInformation: Label;
    labelHeaderTitle: Label;
    labelIsoScorecard: Label;
    labelMilesToPickup: Label;
    labelOrigin: Label;
    labelPendingInvitation: Label;
    labelStatusHistory: Label;
    layoutCarrierPrequalResult: CarrierPrequalResult;
    layoutDispatchCommentsErrors: DispatchCommentsErrors;
    layoutDriverInformation: DriverInformation;
    layoutMovementPay: MovementPay;
    layoutRecentCallins: RecentCallins;
    panelCarrierInfo: Panel;
    panelContact: Panel;
    panelDestination: Panel;
    panelEquipment: Panel;
    panelHeader: Panel;
    panelIsoScorecard: Panel;
    panelOrigin: Panel;
    panelProgress: Panel;
    panelReference: Panel;
    panelSmc3Documents: Panel;
    panelSmc3StatusHistory: Panel;
    panelSpacer9: Panel;
    panelTerminalInfo: Panel;
    panelUnknownCarrier: Panel;
    savebuttonAssign: Button;
    sourceCallin: DataSource;
    sourceCarrier: DataSource;
    sourceCarrierInsCtrl: DataSource;
    sourceCarriersForAssignment: DataSource;
    sourceComments: DataSource;
    sourceInvitedCarrier: DataSource;
    sourceMovement: DataSource;
    sourceReferenceNumber: DataSource;
    sourceTerminalInfo: DataSource;
    starRating1: StarRating;
    tab1: Tab;
    tabsetContent: Tabset;
    textbox1DestPhone: Textbox;
    textboxBouncedBookings: Textbox;
    textboxCarrierContact: Textbox;
    textboxCarrierEmail: Textbox;
    textboxCarrierPhone: Textbox;
    textboxCarrierProNum: Textbox;
    textboxCarrierTractor: Textbox;
    textboxCarrierTrailer: Textbox;
    textboxCarrierTrailerType: Textbox;
    textboxCompanyTrailer: Textbox;
    textboxDestEmail: Textbox;
    textboxDestLocation: Textbox;
    textboxFileType: Textbox;
    textboxKpiScore: Textbox;
    textboxOnTimeDelivery: Textbox;
    textboxOnTimePickup: Textbox;
    textboxOrigEmail: Textbox;
    textboxOrigLocation: Textbox;
    textboxOrigPhone: Textbox;
    textboxOrigTerm: Textbox;
    textboxOverridePayee: Textbox;
    textboxPendingCarrierId: Textbox;
    textboxPendingCarrierIdType: Textbox;
    textboxPendingCarrierName: Textbox;
    textboxPendingPayeeId: Textbox;
    textboxPrequalVendor: Textbox;
    textboxReferenceNumber: Textbox;
    textboxTermName: Textbox;
    textboxTotalLoads: Textbox;
}
